import { areAllRequiredDocsPresent } from '../areAllRequiredDocsPresent';
import { getRequiredDocuments } from '../getRequiredDocuments';

export function canSkipSupportingDocs(): boolean {
    const allRequiredDocsPresent = areAllRequiredDocsPresent();
    // Includes the brand's mandatory documents, not just the lender's — a brand
    // that enforces extra documents must not be skipped past this screen.
    const requiredDocs = getRequiredDocuments();

    if (!allRequiredDocsPresent) return false;

    // Nothing to collect at all — the screen has nothing to show, but there is
    // also nothing to skip, so fall through to it rather than auto-submitting.
    if (!requiredDocs) return false;

    // Everything asked for has already been uploaded (typically the driver's
    // licence captured back on the Identification screen), so the screen would
    // render as a list of completed tiles with nothing left to do.
    return true;
}
